import { toast } from "react-toastify";
import { ServiceBase } from "./ServiceBase";
import api from "./api";
import { ErrorList, Response } from "../models/responseType";
import { Employee, EmployeeToRegister, UpdatePhotoFromLinkRequest } from "../models/employeeType";

export class EmployeeService extends ServiceBase {

    async addEmployeeFromLinkRegister(data: Employee) {
        return new Promise<Response<any>>(async (resolve, reject) => {
            await api.post('employee/AddEmployeeLinkRegister', data)
                .then((response: any) => {
                    let result: Response<any> = response.data;
                    this.handleAfterRequest(result);
                    resolve(result);
                }).catch(error => {
                    const result: Response<any> | undefined = error.response?.data;
                    if (result) {
                        this.handleAfterRequest(result);
                        resolve(result);
                    } else {
                        toast.error('Não foi possível enviar o cadastro. Verifique sua conexão e tente novamente.');
                        resolve({ isSuccess: false, message: '', errorList: [], data: null });
                    }
                });
        });
    }

    async enableToRegisterAsync(employeeId: number) {
        return new Promise<boolean>(async (resolve) => {
            await api.post(`employee/EnableToRegister/${employeeId}`)
                .then((response: any) => {
                    let result: Response<any> = response.data;
                    this.handleAfterRequest(result);
                    resolve(result.isSuccess);
                }).catch(error => {
                    const result = this.toErrorResponse(error.response?.data);
                    if (result) {
                        toast.error(result.errorList[0]?.errorMessage || 'Não foi possível liberar o funcionário.');
                    } else {
                        toast.error('Não foi possível liberar o funcionário. Verifique sua conexão e tente novamente.');
                    }
                    resolve(false);
                });
        });
    }

    async getEmployeeToRegisterAsync(employeeId: number, eventId: number, companyId: number) {
        return new Promise<Response<EmployeeToRegister | null>>(async (resolve) => {
            await api.get(`employee/FindToRegister/${employeeId}`, { params: { eventId, companyId } })
                .then((response: any) => {
                    resolve(response.data);
                }).catch(error => {
                    const result = this.toErrorResponse(error.response?.data);
                    // 'network' permite à página diferenciar erro de conexão de funcionário não encontrado
                    resolve(result ?? { isSuccess: false, message: 'network', errorList: [], data: null });
                });
        });
    }

    async updatePhotoFromLinkAsync(data: UpdatePhotoFromLinkRequest) {
        return new Promise<Response<any>>(async (resolve) => {
            await api.post('employee/UpdatePhotoLinkRegister', data)
                .then((response: any) => {
                    let result: Response<any> = response.data;
                    this.handleAfterRequest(result);
                    resolve(result);
                }).catch(error => {
                    const result = this.toErrorResponse(error.response?.data);
                    if (result) {
                        this.handleAfterRequest(result);
                        resolve(result);
                    } else {
                        toast.error('Não foi possível enviar a foto. Verifique sua conexão e tente novamente.');
                        resolve({ isSuccess: false, message: '', errorList: [], data: null });
                    }
                });
        });
    }

    // O EmployeeController responde 400 com a lista de erros; demais rotas respondem com o envelope Response<T>
    private toErrorResponse(body: unknown): Response<null> | undefined {
        if (Array.isArray(body))
            return { isSuccess: false, message: '', errorList: body as ErrorList[], data: null };

        if (body && typeof body === 'object' && 'isSuccess' in body) {
            const result = body as Response<null>;
            return { ...result, errorList: result.errorList ?? [], data: null };
        }

        return undefined;
    }
}
